import _taggedTemplateLiteral from "/home/jenkins/agent/workspace/rtal_Jobs_Portal_Pipeline_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject;

import { createGlobalStyle } from 'styled-components';
import { makeGlobalStyles } from './mixins';
/**
 * Container widths
 * Set the container width, and override it for fixed navbars in media queries.
 */

export var GlobalStyles = createGlobalStyle(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", ""])), function (props) {
  return makeGlobalStyles(props);
});